import { Injectable } from "@nestjs/common";
import { AssetServiceDto } from "./asset-service.dto";
import { AssetService } from "../asset-service.entity";
import { AssetServiceChecklist } from "../asset-service-checklist.entity";

@Injectable()
export class AssetServiceAdapater {
    public convertDtoToEntity(assetsDto: AssetServiceDto | any): AssetService[] {
        const assetsArr : AssetService[] = []
        for(const id of assetsDto.assetId){
        const assets = new AssetService()
        assets.assetServeId = assetsDto.assetServeId;
        assets.assetId = id;
        assets.assetName = assetsDto.assetName;
        assets.assetCategory = assetsDto.assetCategoryId;
        assets.assetServiceDate = assetsDto.assetServiceDate;
        assets.actAssetServiceDate = assetsDto.actAssetServiceDate;
        assets.isActive = assetsDto.isActive === undefined ? true : assetsDto.isActive;
        assets.serviceProvider = assetsDto.serviceProvider;
        assets.status = assetsDto.status;
        assets.serviceName = assetsDto.serviceName;
        assets.remarks = assetsDto.remarks;
        assets.serviceOwner = assetsDto.serviceOwner;
        assets.phoneNumber = assetsDto.phoneNumber;
        assets.serviceType = assetsDto.serviceType
        const checkListEntity: AssetServiceChecklist[] = []
        for (const element of assetsDto.assetServiceChecklist) {
            const assetServiceChecklistEnt = new AssetServiceChecklist()
            assetServiceChecklistEnt.checklist = element.checklist
            assetServiceChecklistEnt.checklistStatus = element.checklistStatus
            assetServiceChecklistEnt.createdUser = element.createdUser;
            checkListEntity.push(assetServiceChecklistEnt)
        }
        assets.assetServiceChecklist = checkListEntity
        assetsArr.push(assets)
    }
        return assetsArr;
    }
}